import React from 'react';
import { Wifi, WifiOff } from 'lucide-react';

const WebSocketFooter = () => {
  return (
    <div className="mt-12 border-t border-gray-200 pt-8">
      <div className="bg-gray-50 border border-gray-200 rounded-lg p-6">
        <div className="flex items-start gap-4">
          <div className="p-2 bg-orange-100 rounded-lg">
            <WifiOff className="h-5 w-5 text-orange-600" />
          </div>
          <div className="flex-1">
            <h3 className="text-sm font-semibold text-gray-900 mb-2">Real-Time Updates Currently Disabled</h3>
            <p className="text-sm text-gray-600 mb-3">
              WebSocket connections are disabled to prevent system overload and maintain optimal performance in this demo environment.
            </p>
            <div className="text-sm text-gray-700">
              <div className="font-medium mb-2">To enable real-time updates in production:</div>
              <ul className="list-disc list-inside space-y-1 text-gray-600">
                <li>Configure WebSocket server with proper load balancing</li>
                <li>Set up Redis or similar for message queuing</li>
                <li>Implement connection throttling and rate limiting</li>
                <li>Add monitoring for WebSocket connection health</li>
                <li>Enable in environment configuration: <code className="bg-gray-200 px-2 py-1 rounded text-xs">ENABLE_WEBSOCKETS=true</code></li>
              </ul>
            </div>
            <div className="flex items-center gap-2 mt-4 text-sm text-gray-500">
              <Wifi className="h-4 w-4" />
              <span>Manual refresh available via page reload or action buttons</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WebSocketFooter;